
import { SETTINGS, CHANGE_ENRICHMENT_SETTING,APP_VERSION_SETTING } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import { changeParamsToQuery } from './commonFn';

export class SettingService {

  static instance;
  static getInstance() {
    if (!SettingService.instance) {
      SettingService.instance = new SettingService();
    }
    return SettingService.instance;
  }

  fetchSetting = async (params) => {
    let newsResponse = await Api.get(`${SETTINGS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  saveSetting = async (params) => {
    let newsResponse = await Api.post(`${SETTINGS.URL}`, params);
    return newsResponse;
  }

  changeEnrichmentSetting = async (params) => {
    let newsResponse = await Api.post(`${CHANGE_ENRICHMENT_SETTING.URL}`, params);
    return newsResponse;
  }

  viewEnrichmentSetting = async (params) => {
    let newsResponse = await Api.get(`${CHANGE_ENRICHMENT_SETTING.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  saveAppVersion = async (params) => {
    let newsResponse = await Api.post(`${APP_VERSION_SETTING.URL}`, params);
    return newsResponse;
  }
  getAppVersion = async (params) => {
    let newsResponse = await Api.get(`${APP_VERSION_SETTING.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }








}

